import { render } from "./CpfCnpjFieldContainer.vue?vue&type=template&id=78af0899"
import script from "./CpfCnpjFieldContainer.vue?vue&type=script&lang=js"
export * from "./CpfCnpjFieldContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__